import React from 'react'

export default () => (
  <svg viewBox="0 0 24 24">
    <path fillRule="evenodd" clipRule="evenodd" d="M21 11.4721H5.85632L11.0345 5.77209L10.3506 5.0332L4 11.9999L10.3506 18.9665L11.0345 18.2276L5.85632 12.5276H21V11.4721Z" fill="currentColor"/>
  </svg>
)
